<template>
    <img class="flame" src="@/assets/Flamme.png" @click="$router.push('/home/'+this.routeParams)">
    <button v-if="this.$route.name == 'home' || this.$route.name == 'home2'" class="menu fa" :class="this.menuActive?'menuActive':'menuDeactive'" @click="this.menuActive = !this.menuActive">&#xf0c9;</button>
    <button v-if="this.$route.name != 'home' && this.$route.name != 'home2'" class="back fa" @click="this.$router.back">&#xf104;</button>
    <Menu @closeMenu="this.menuActive = false;" :menuActive="this.menuActive" @toView="this.newView" @updateBerechtigungen="this.updateBerechtigungen"/>
</template>

<script>
import Menu from './Home/Menu.vue';

export default {
  name: 'Header',
  components:{
    Menu
  },
  props: {
    ueberschrift: String
  },
  data() {
    return {
      menuActive: false,
      routeParams: String,
      berechtigungen: []
    };
  },
  watch: {
    $route(to, from){
      this.menuActive = false;
    }
  },
  methods: {
    updateBerechtigungen(newBerechtigungen){
      this.berechtigungen = newBerechtigungen;
      this.$emit('updateBerechtigungen', this.berechtigungen);
    },
  },
  created(){
    this.routeParams = this.$route.params.id;
  }
}
</script>

<style lang="scss">
.flame{
    height: 4rem;
    display: block;
    position:fixed;
    right: 1rem;
    top: 1rem;
    z-index: 2;
    cursor: pointer;
}

.menu, .back{
  width: 2.7rem;
  height: 2.7rem;
  border: solid rgb(236, 236, 236) 1px;
  background-color:white;
  border-radius: 50%;
  //border: none;
  //background-color: transparent;
  color: rgb(34, 34, 34);
  position: fixed;
  left: 2rem;
  top: 2rem;
  z-index: 50;
  //box-shadow: 0 4px 12px rgb(235, 235, 235);
}

.menu:hover, .back:hover{
  //transform: scale(1.05);
  cursor: pointer;
}

.menuActive{
  transform: rotateZ(-90deg);
  transition: transform 0.3s;
}

.menuDeactive{
  transform: rotateZ(0deg);
  transition: transform 0.3s;
}

.back{
    font-size: x-large;
    font-weight: bold;
}
</style>